import { installSteps } from '@/mocks/home';

export default function InstallSteps() {
  return (
    <section id="install" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-none px-4 py-12 md:px-6 md:py-16">
        <div className="max-w-2xl">
          <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-accent-600">
            <i className="ri-list-check-2" />
            Install Guide
          </p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">安装四步走</h2>
          <p className="mt-2 text-sm text-foreground-600">
            从核对系统版本到完成首次配置，跟着步骤走，安卓与 iOS 都能顺利装好。
          </p>
        </div>

        <ol className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5">
          {installSteps.map((step) => (
            <li
              key={step.no}
              className="relative flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
            >
              <span className="font-heading text-3xl font-bold text-primary-300">{step.no}</span>
              <h3 className="mt-3 text-sm font-bold text-foreground-950 md:text-base">{step.title}</h3>
              <p className="mt-2 text-xs leading-relaxed text-foreground-600">{step.summary}</p>
              <i className="ri-road-map-line absolute right-4 top-4 text-xl text-background-300" />
            </li>
          ))}
        </ol>

        <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="rounded-lg border border-primary-200 bg-primary-50 p-4 md:p-5">
            <h3 className="flex items-center gap-2 text-sm font-bold text-primary-800">
              <i className="ri-android-line text-lg" />
              安卓安装要点
            </h3>
            <ul className="mt-3 space-y-2 text-xs leading-relaxed text-primary-900/80">
              <li className="flex gap-2">
                <i className="ri-check-line mt-0.5 text-primary-600" />
                在设置中允许「安装未知应用」，完成后可随时关闭
              </li>
              <li className="flex gap-2">
                <i className="ri-check-line mt-0.5 text-primary-600" />
                安装包建议保存在下载目录，方便失败后重新尝试
              </li>
            </ul>
          </div>
          <div className="rounded-lg border border-accent-200 bg-accent-50 p-4 md:p-5">
            <h3 className="flex items-center gap-2 text-sm font-bold text-accent-800">
              <i className="ri-apple-line text-lg" />
              iOS 安装要点
            </h3>
            <ul className="mt-3 space-y-2 text-xs leading-relaxed text-accent-900/80">
              <li className="flex gap-2">
                <i className="ri-check-line mt-0.5 text-accent-600" />
                下载描述文件后，前往「设置 - 通用 - VPN 与设备管理」信任
              </li>
              <li className="flex gap-2">
                <i className="ri-check-line mt-0.5 text-accent-600" />
                信任完成后返回桌面，图标即可正常打开
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}